import React from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { ModalClose } from "components/menu/Labels";
import './FormModal.css'

type IModalButtonProps = {
    onClick: () => void,
    text: string,
    primaryButton?: boolean
}

export const ModalButton = (props: IModalButtonProps) => {
    return (
        <React.Fragment>
            <Button className={props.primaryButton == true ? "btn-primary" : "btn-secondary"} onClick={props.onClick}>{props.text}</Button>
        </React.Fragment>
    );
}


type IModalButtonRowProps = {
    children: any
}

export const ModalButtonRow = (props: IModalButtonRowProps) => {
    return (
        <React.Fragment>
            <div className="action-button-container pt-2 pb-2">
                {props.children}
            </div>
        </React.Fragment>
    );
}


type ISubHeaderProps = {
    children: any
}

export const FormModalSubHeader = (props: ISubHeaderProps) => {
    return (
        <React.Fragment>
            <div className="container">
                <div className="row modal-sub-header pt-3 pb-3">
                    <div className="col-1" />
                    <div className="col-10">{props.children}</div>
                    <div className="col-1" />
                </div>
            </div>
        </React.Fragment>
    );
}


type IPaddedBodyProps = {
    children: any
}

export const FormModalPaddedBody = (props: IPaddedBodyProps) => {
    return (
        <React.Fragment>
            <div className="container">
                <div className="row pt-5 pb-5 pl-3 pr-3">
                    {props.children}
                </div>
            </div>
        </React.Fragment>
    );
}


type IFormModalProps = {
    children: any,
    isOpen: boolean,
    closeAction: () => void,
    headingText: string,
    submitAction?: () => void,
    icon?: any
}

export const FormModal = (props: IFormModalProps) => {
    return (
        <React.Fragment>
            <Modal isOpen={props.isOpen} className="document-form-modal">
                <ModalHeader className="p-0">
                    <div className="container secondary-card-heading alternate-text p-0">
                        <div className="row pt-1 pb-1 m-0">
                            <div className="col-1 pt-3 pb-3 h3-icon">{props.icon}</div>
                            <div className="col-10 mt-2 pt-4 h3-text">{props.headingText}</div>
                            <div className="col-1 pt-1"><ModalClose onClick={props.closeAction} /></div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="p-0">
                    {props.children}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}
